module["exports"] = [
  "Jr.",
  "Sr.",
  "I",
  "II",
  "III",
  "IV",
  "V"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nb_NO/name/suffix.js
 ** module id = 774
 ** module chunks = 0
 **/